import { ScreenAppraisals } from '@app-velocity/modules/appraisals';

import { CreateAReviewCard } from '../../../../components/CreateAReviewCard';

import { useWorkspaceContext } from '../../context/useWorkspaceContext';

export const ReviewsSection = () => {
  const { anyAppraisals, anyChallengesOrAppraisals, fileId } =
    useWorkspaceContext();

  if (import.meta.env.VITE_APPRAISALS_ENABLED !== 'true') return null;

  if (!anyAppraisals)
    return (
      <CreateAReviewCard
        mode="authorized"
        withLinks={anyChallengesOrAppraisals}
      />
    );

  return <ScreenAppraisals fileId={fileId} />;
};
